import { useAuth0 } from "@auth0/auth0-react";
import tradeDataStore from "@/store/tradeDataStore";
import { getAllActionSummaryData } from "@/store/tradeDataStoreACTIONS";
import { useRouter } from "@/lib/navigation";
import TradeTileHandler from "./TradeTileHandler";
import { IActiveId } from "@/lib/widgetsLayoutDir";
import { useEffect } from "react";

interface ITradeTile {
  cryptoID?: string | undefined; // Popout will pass in undefined
  loadedFromPopout?: boolean;
  esidToPass: string;
  activeId?: Partial<IActiveId>;
}

const TradeTileIndex = ({
  cryptoID,
  loadedFromPopout = false,
  esidToPass,
  activeId,
}: ITradeTile) => {
  // Method of handling the URL string
  const tradeData = tradeDataStore((state) => state.tradeData);
  const router = useRouter();

  const { getAccessTokenSilently } = useAuth0();

  // Need to make sure data is loaded when using a seperate browser.
  // LQC-2207: mount only. From the render body this refires on every re-render
  // whenever the summary comes back with no active trades.
  useEffect(() => {
    if (loadedFromPopout && tradeData.length == 0) {
      getAllActionSummaryData(getAccessTokenSilently);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TradeTileHandler
      cryptoID={cryptoID} // no need to pass cryptoID when using Pop out - will be undefiend
      loadedFromPopout={loadedFromPopout} // Passing true will use the ESID rather than the logic to get it off the ID
      esidToPass={esidToPass}
      router={router}
      activeId={activeId}
      tradeData={tradeData}
    />
  );
};

export default TradeTileIndex;
